import { Box } from '@mantine/core';
import {
	type EntityViolationsOut,
	type PolicyOut,
	type PolicyViolationOut,
} from '@repo/api-codegen';
import { Button } from '@repo/foundations';
import { useCallback } from 'react';
import { ResourceDisplay } from '../../../PoliciesPage/render';
import policyIssueStore from '../PolicyIssues/store';
import { useStyles } from '../PolicyIssues/styles';

export function IgnoredResourceRow({
	result,
	policy,
	handleReopenIssue,
	readOnly = false,
}: {
	result: EntityViolationsOut;
	policy: PolicyOut;
	handleReopenIssue: (
		e: React.MouseEvent<HTMLButtonElement>,
		violations: PolicyViolationOut[]
	) => void;
	readOnly?: boolean;
}) {
	const { classes } = useStyles();
	const handleResourceClick = useCallback(
		async (id: string, violations?: PolicyViolationOut[]) => {
			policyIssueStore.openPolicyIssueSidebarWithId(
				policy,
				violations ?? [],
				id
			);
		},
		[policy]
	);

	return (
		<Box
			className={classes.rowContainer}
			onClick={() => handleResourceClick(result.entity.id, result.violations)}
		>
			<ResourceDisplay record={result.entity as any} />
			<Button
				variant="default"
				onClick={(e) => handleReopenIssue(e, result.violations)}
				disabled={readOnly}
			>
				Re-open issue
			</Button>
		</Box>
	);
}
